import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref } from "vue";
import { Edit, Search } from '@element-plus/icons-vue';
import apis from "@/api";
import { ElMessage, ElMessageBox } from "element-plus";
import MonitorStatus from './components/MonitorStatus';
import AdvertLaunchAdd from './components/AdvertLaunchAdd';
import AdvertLaunchInfo from './components/AdvertLaunchInfo';
import AdvertLaunchResult from './components/AdvertLaunchResult';
import AdvertLaunchManyMonitor from './components/AdvertLaunchManyMonitor';
import { deleteAdvertLaunchMonitor, getAdvertLaunchMonitorPage, getAreaCodeList } from "../../../api/modules/advert";
import AdvertLaunchCompanyList from "@/views/Advert/AdvertLaunchMonitor/components/AdvertLaunchCompanyList.vue";
export default {
  __name: 'AdvertLaunchMonitorList',
  props: {
    roleFlag: {
      type: String,
      default: ""
    },
    roleId: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const viewVisible = computed(() => {
      return props.roleFlag === '1';
    });
    const props = __props;
    const advertAdd = ref();
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const data = reactive({
      queryParam: {
        contractCode: '',
        contractName: '',
        areaCode: ''
      },
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      // ,
      // areaSelect: [],
      currentAdertLaunch: {}
    });
    const advertLaunchAddVisible = ref(false);
    const companyVisible = ref(false);
    const companyList = ref();
    const advertLaunchDetailVisible = ref(false);
    const advertLaunchDetailTitle = ref("");
    const currentAction = ref('');
    const advertLaunchResultVisible = ref(false);
    const advertLaunchResultTitle = ref('');
    const advertLaunchManyMonitorVisible = ref(false);
    const advertLaunchManyMonitorTitle = ref('');
    const elLoading = ref(false);
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.getAdvertLaunchMonitorPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };

    //广告投放
    const handleAddAdvertLaunch = () => {
      advertAdd.value.init();
      advertLaunchAddVisible.value = true;
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const deleteConfirm = item => {
      ElMessageBox.alert('确定要删除任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showCancelButton: true
      }).then(() => {
        handleDelete(item);
      }).catch(() => {});
    };
    //删除
    const handleDelete = item => {
      apis.deleteAdvertLaunchMonitor({
        id: item.id
      }).then(res => {
        if (res.success) {
          ElMessage.success("删除成功!");
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
      });
    };

    //认领任务
    const handlePickTask = row => {
      const param = {
        id: row.id,
        monitorRoleId: props.roleId
      };
      apis.handlePickTask(param).then(res => {
        if (res.success) {
          ElMessage.success("认领成功!");
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
      });
    };

    //查看投放任务
    const handleView = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailView';
      advertLaunchDetailTitle.value = "投放任务明细";
      advertLaunchDetailVisible.value = true;
    };
    //新建投放任务明细
    const handleDetailAdd = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailAdd';
      advertLaunchDetailTitle.value = "新建投放任务明细";
      advertLaunchDetailVisible.value = true;
    };
    //完善投放任务明细
    const handleDetailEdit = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailEdit';
      advertLaunchDetailTitle.value = "完善投放任务明细";
      advertLaunchDetailVisible.value = true;
    };
    //复核比对重择监测图片
    const handleCheckRecordCompare = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'checkRecordCompare';
      advertLaunchDetailTitle.value = "复核比对";
      advertLaunchDetailVisible.value = true;
    };
    //上传上画照片
    const handleRealityUpload = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'realityUpload';
      advertLaunchDetailTitle.value = "上传上画照片";
      advertLaunchDetailVisible.value = true;
    };
    //审核 row-待审核供应商 activeRow-投放任务
    const handleDetailAudit = (row, activeRow) => {
      activeRow.currentRoleId = row.roleId;
      data.currentAdertLaunch = activeRow;
      currentAction.value = 'detailAudit';
      advertLaunchDetailTitle.value = "审核投放任务";
      advertLaunchDetailVisible.value = true;
    };
    //宣传管理员审核投放公司认领
    const handleCompanyAudit = row => {
      companyVisible.value = true;
      companyList.value.init(row);
    };
    //投放公司认领任务
    const handleCompanyPickTask = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'companyPick';
      advertLaunchDetailTitle.value = "认领投放明细";
      advertLaunchDetailVisible.value = true;
    };
    //比对
    const handleMonitor = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailMonitor';
      advertLaunchDetailTitle.value = "比对投放任务明细";
      advertLaunchDetailVisible.value = true;
    };
    //查看比对结果
    const handleCompareResultView = row => {
      if (row.monitorState == 13) {
        ElMessage.info("任务待比对,稍后再来看看吧!");
        return;
      }
      if (row.monitorState == 6) {
        ElMessage.info("任务正在比对中,比对完成再来看看吧!");
        return;
      }
      data.currentAdertLaunch = row;
      currentAction.value = 'compareResult';
      advertLaunchResultVisible.value = true;
      advertLaunchResultTitle.value = "比对结果";
    };
    //查看多次监测
    const handleManyMonitorView = row => {
      if (row.monitorState != 9) {
        ElMessage.info("初识任务未结束,无法查看比对任务结果！");
        return;
      }
      data.currentAdertLaunch = row;
      currentAction.value = 'manyMonitor';
      advertLaunchManyMonitorVisible.value = true;
      advertLaunchManyMonitorTitle.value = "比对结果";
    };
    const loadAllArea = () => {
      apis.getAreaCodeList().then(res => {
        if (res.success) {
          data.areaSelect = res.data;
        }
      });
    };
    onMounted(() => {
      loadData();
      loadAllArea();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "合同编码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.contractCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.queryParam.contractCode = $event),
            placeholder: "请输入合同编码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "合同名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.contractName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.queryParam.contractName = $event),
            placeholder: "请输入合同名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "任务名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.taskName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.queryParam.taskName = $event),
            placeholder: "请输入任务名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), __props.roleFlag == '2' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "供应商"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.opCompany,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.queryParam.opCompany = $event),
            placeholder: "请输入供应商"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), __props.roleFlag == '2' && __props.roleId == 'launchMonitor_0000' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "地区"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: data.queryParam.areaCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.queryParam.areaCode = $event),
            placeholder: "",
            onChange: loadData
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.areaSelect, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: loadData,
            plain: ""
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("查询", -1)]))]),
            _: 1
          }, 8, ["icon"]), viewVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            icon: _unref(Edit),
            onClick: handleAddAdvertLaunch
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("管理员新增投放", -1)]))]),
            _: 1
          }, 8, ["icon"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        "empty-text": "",
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "taskName",
          label: "任务名称"
        }), _createVNode(_component_el_table_column, {
          prop: "opCompany",
          label: "执行公司"
        }), _createVNode(_component_el_table_column, {
          prop: "opName",
          label: "执行人"
        }), _createVNode(_component_el_table_column, {
          prop: "contractCode",
          label: "合同编码"
        }), _createVNode(_component_el_table_column, {
          prop: "contractName",
          label: "合同名称"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          prop: "monitorState",
          label: "监测状态"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(MonitorStatus), {
            "monitor-state": scope.row.monitorState,
            "examine-state": scope.row.examineState ? scope.row.examineState : scope.row.examineState === 0 ? 0 : -1
          }, null, 8, ["monitor-state", "examine-state"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [scope.row.monitorState != 9 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '1' && scope.row.monitorState == -1 || scope.row.monitorState == 5 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleDetailAdd(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("新建投放任务明细", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag === '0' && scope.row.monitorState === 7 && (scope.row.examineState === 4 || scope.row.examineState === 1) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleDetailEdit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("完善投放任务明细", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag === '0' && scope.row.examineState === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleRealityUpload(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("上传上画照片", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '1' && scope.row.monitorState == 7 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCompanyAudit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("审核投放材料", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag === '0' && scope.row.monitorState === 7 && scope.row.examineState === 3 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCompanyPickTask(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("认领投放任务明细", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '2' && (scope.row.monitorState == 1 || scope.row.monitorState == 4) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handlePickTask(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("认领监测任务", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '2' && scope.row.monitorState == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleMonitor(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("去比对", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [(__props.roleFlag == '2' || __props.roleFlag == '3') && (scope.row.monitorState == 0 || scope.row.monitorState == 6 || scope.row.monitorState == 10 || scope.row.monitorState == 13 || scope.row.monitorState == 12) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleCompareResultView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("查看比对结果", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), (__props.roleFlag == '0' || __props.roleFlag == '1' || __props.roleFlag == '2' || __props.roleFlag == '3') && scope.row.monitorState == 9 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleManyMonitorView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("查看比对任务", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '1' && scope.row.monitorState == 10 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCompareResultView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("审核复核比对任务", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '2' && scope.row.monitorState == 11 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCheckRecordCompare(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("去复核比对", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '1' && (scope.row.monitorState == -1 || scope.row.monitorState == 5) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => deleteConfirm(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])])]), _createVNode(_unref(AdvertLaunchAdd), {
        ref_key: "advertAdd",
        ref: advertAdd,
        visible: advertLaunchAddVisible.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = $event => advertLaunchAddVisible.value = $event),
        onSuccess: loadData,
        "role-id": __props.roleId
      }, null, 8, ["visible", "role-id"]), _createVNode(AdvertLaunchCompanyList, {
        ref_key: "companyList",
        ref: companyList,
        visible: companyVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = $event => companyVisible.value = $event),
        onSuccess: loadData,
        onAudit: handleDetailAudit,
        "role-flag": __props.roleFlag,
        "role-id": __props.roleId
      }, null, 8, ["visible", "role-flag", "role-id"]), _createVNode(_unref(AdvertLaunchInfo), {
        visible: advertLaunchDetailVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = $event => advertLaunchDetailVisible.value = $event),
        title: advertLaunchDetailTitle.value,
        "advert-launch": data.currentAdertLaunch,
        "role-id": __props.roleId,
        "role-flag": __props.roleFlag,
        "current-action": currentAction.value,
        onRefresh: loadData
      }, null, 8, ["visible", "title", "advert-launch", "role-id", "role-flag", "current-action"]), _createVNode(_unref(AdvertLaunchResult), {
        visible: advertLaunchResultVisible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = $event => advertLaunchResultVisible.value = $event),
        title: advertLaunchResultTitle.value,
        "role-id": __props.roleId,
        "role-flag": __props.roleFlag,
        "advert-launch": data.currentAdertLaunch,
        "current-action": currentAction.value,
        onTaskEnd: loadData
      }, null, 8, ["visible", "title", "role-id", "role-flag", "advert-launch", "current-action"]), _createVNode(_unref(AdvertLaunchManyMonitor), {
        visible: advertLaunchManyMonitorVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => advertLaunchManyMonitorVisible.value = $event),
        title: advertLaunchManyMonitorTitle.value,
        "role-id": __props.roleId,
        "role-flag": __props.roleFlag,
        "advert-launch": data.currentAdertLaunch,
        "current-action": currentAction.value,
        onTaskEnd: loadData
      }, null, 8, ["visible", "title", "role-id", "role-flag", "advert-launch", "current-action"])], 64);
    };
  }
};